import React, { useState } from 'react';
import { Offcanvas, Tab } from 'react-bootstrap';
import { BasicInfo, GeneralInfo } from './components';
import SupervisorAndNotes from './components/SupervisorAndNotes';
import NoDataBlock from 'components/common/NoDataBlock';
import TabWraper from 'components/pages/TabWrapper';

export default function AddUpdateFleet({ show, onCloseModal, fleetId }) {
  const [activeTab, setActiveTab] = useState('general');

  return (
    <>
      <Offcanvas
        show={show}
        onHide={onCloseModal}
        placement={'end'}
        backdropClassName="custom-drawer"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title className="d-flex align-items-center">
            <span className="me-1">{fleetId ? 'Viewing Fleet' : 'Creating Fleet'}</span>
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          {fleetId && <BasicInfo />}
          <TabWraper
            id="controlled-tab"
            activeKey={activeTab}
            onSelect={k => setActiveTab(k)}
            visibleItems={fleetId ? ['general', 'note', 'history'] : ['general']}
          >
            <Tab
              eventKey="general"
              title="General"
              tabClassName="fs-1"
              className="border-bottom border-x p-3"
            >
              <GeneralInfo />
            </Tab>
            <Tab
              eventKey="note"
              title="Supervisors/Notes"
              tabClassName="fs-1"
              className="border-bottom border-x p-3"
            >
              <SupervisorAndNotes />
            </Tab>
            <Tab
              eventKey="history"
              title="History"
              tabClassName="fs-1"
              className="border-bottom border-x p-3"
            >
              <NoDataBlock />
            </Tab>
          </TabWraper>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}
